export const INIT_FROM_DRUPAL = 'INIT_FROM_DRUPAL';
export const INIT_FROM_COOKIES = 'INIT_FROM_COOKIES';
export const UPDATE_LOCALE = 'UPDATE_LOCALE';
export const UPDATE_FROM_BACKEND = 'UPDATE_FROM_BACKEND';
export const RECEIVE_FROM_BACKEND = 'RECEIVE_FROM_BACKEND';
export const UPDATE_VALUE = 'UPDATE_VALUE';
export const UPDATE_CUSTOMER_INFO = 'UPDATE_CUSTOMER_INFO';
export const UPDATE_CUSTOMER_DIALCODE = 'UPDATE_CUSTOMER_DIALCODE';
export const UPDATE_CUSTOMER_PHONE = 'UPDATE_CUSTOMER_PHONE';
export const PAY = 'PAY';
export const ACCEPT_TERMS = 'ACCEPT_TERMS';
export const UPDATE_EXTRA_SERVICES = 'UPDATE_EXTRA_SERVICES';
export const UPDATE_TICKETS = 'UPDATE_TICKETS';
export const UPDATE_TOTAL_STEPS = 'UPDATE_TOTAL_STEPS';
export const SELECT_PAYMENT_TYPE = 'SELECT_PAYMENT_TYPE';
export const SELECT_PAYMENT_OPTION = 'SELECT_PAYMENT_OPTION';
export const UPDATE_SALES_CHANNEL = 'UPDATE_SALES_CHANNEL';
export const UPDATE_AGENCY_NUMBER = 'UPDATE_AGENCY_NUMBER';
export const UPDATE_AGENCY_MESSAGE = 'UPDATE_AGENCY_MESSAGE';
export const UPDATE_AGENCY_SUB_ID = 'UPDATE_AGENCY_SUB_ID';
export const UPDATE_ORDER_TYPE = 'UPDATE_ORDER_TYPE';
export const UPDATE_AGENCY_USER_ID = 'UPDATE_AGENCY_USER_ID';
export const START_SUBMIT_LOADING = 'START_SUBMIT_LOADING';
export const FIRE_CUSTOMER_INFO_ERROR = 'FIRE_CUSTOMER_INFO_ERROR';
export const FIRE_FINAL_CLEANING_ERROR = 'FIRE_FINAL_CLEANING_ERROR';
export const CLEAN_CUSTOMER_ERRORS = 'CLEAN_CUSTOMER_ERRORS';
export const CLEAN_CUSTOMER_ERROR = 'CLEAN_CUSTOMER_ERROR';
export const FIRE_BACKEND_ERROR = 'FIRE_BACKEND_ERROR';
export const FIRE_PAYMENT_ERROR = 'FIRE_PAYMENT_ERROR';
export const FIRE_ABANDON_BASKET_ERROR = 'FIRE_ABANDON_BASKET_ERROR';
export const FIRE_TERMS_AND_CONDITIONS_ERROR =
  'FIRE_TERMS_AND_CONDITIONS_ERROR';
export const FIRE_AGENCY_SUB_ID_ERROR = 'FIRE_AGENCY_SUB_ID_ERROR';
export const UPDATE_GUEST_OPTIONS = 'UPDATE_GUEST_OPTIONS';
export const UPDATE_ADDITIONAL_CHILDREN = 'UPDATE_ADDITIONAL_CHILDREN';
export const ADD_SECURITY_PACKAGE_LINK = 'ADD_SECURITY_PACKAGE_LINK';
export const UPDATE_NARROW_STATE = 'UPDATE_NARROW_STATE';
export const NEXT_STEP = 'NEXT_STEP';
export const PREV_STEP = 'PREV_STEP';
export const SET_ORIGINAL_AGENCY_INFO = 'SET_ORIGINAL_AGENCY_INFO';
export const FIRE_PAY_BUTTON_CLICK = 'FIRE_PAY_BUTTON_CLICK';
export const RESET_STATE = 'RESET_STATE';
export const UPDATE_BOOKING_OVERVIEW = 'UPDATE_BOOKING_OVERVIEW';
export const UPDATE_VOUCHER_BACKEND = 'UPDATE_VOUCHER_BACKEND';
export const UPDATE_VOUCHER_CODE = 'UPDATE_VOUCHER_CODE';
export const FIRE_VOUCHER_ERROR = 'FIRE_VOUCHER_ERROR';
export const STOP_LOADING = 'STOP_LOADING';
export const INTERACT_CUSTOMER_INFO = 'INTERACT_CUSTOMER_INFO';
export const CUSTOMER_LEAVE = 'CUSTOMER_LEAVE';
export const UPDATE_ABANDON_BASKET_STATE = 'UPDATE_ABANDON_BASKET_STATE';
export const HIDE_ABANDON_BASKET = 'HIDE_ABANDON_BASKET';
export const RECEIVED_DIBS_FORM = 'RECEIVED_DIBS_FORM';
export const SEND_ABANDON_BASKET = 'SEND_ABANDON_BASKET';
export const TOGGLE_ABANDON_BASKET_TERMS = 'TOGGLE_ABANDON_BASKET_TERMS';
